// Sidebar.jsx
// Client: vmfive
// Version: 1.0.0
// Product: Ad SaaS — Navigation sidebar with logo, nav items, and footer

import React from 'react';
import { useLayout } from './AppLayout';
import './Sidebar.css';

/**
 * Single navigation item
 */
function SidebarItem({ icon, label, active = false, onClick, href }) {
  const { sidebarCollapsed } = useLayout();
  const Tag = href ? 'a' : 'button';
  const props = href ? { href } : { type: 'button', onClick };

  return (
    <Tag
      {...props}
      className={['sidebar-item', active ? 'sidebar-item--active' : '']
        .filter(Boolean)
        .join(' ')}
      title={sidebarCollapsed ? label : undefined}
    >
      {icon && <span className="sidebar-item__icon">{icon}</span>}
      <span className="sidebar-item__label">{label}</span>
    </Tag>
  );
}

/**
 * Group divider with optional title
 */
function SidebarGroup({ title, children }) {
  return (
    <div className="sidebar-group">
      {title && <div className="sidebar-group__title">{title}</div>}
      {children}
    </div>
  );
}

/**
 * Main Sidebar component — slot-based composition
 */
export default function Sidebar({
  logo,
  subtitle,
  children,
  footer,
}) {
  return (
    <div className="sidebar">
      {/* Logo area */}
      <div className="sidebar__logo">
        <div className="sidebar__logo-text">{logo}</div>
        {subtitle && <div className="sidebar__logo-sub">{subtitle}</div>}
      </div>

      {/* Navigation area — scrollable */}
      <nav className="sidebar__nav">{children}</nav>

      {/* Footer area */}
      {footer && <div className="sidebar__footer">{footer}</div>}
    </div>
  );
}

Sidebar.Item = SidebarItem;
Sidebar.Group = SidebarGroup;
